import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import {resendInviteGroupGuest, resendInviteProviderGuest} from "../../../../api/pro-guest-functions";
import {useApiNotification} from "../../../ui/ApiNotificationProvider";
import * as _ from 'lodash';
import List from "@material-ui/core/List";
import Popover from "@material-ui/core/Popover";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import {Guest} from "../../../../models/pro-guest.models";


interface GuestsActionsProps {
    guest: Guest;
    onRemove: (g: Guest) => void;
    organizationId: number;
    folderId?: number;
    groupId?: number;
}

export const GuestsActions: FC<GuestsActionsProps> = ({
                                                          guest,
                                                          onRemove,
                                                          ...properties
                                                      }) => {
    const {t} = useTranslation();
    const {groupId, folderId, organizationId} = properties;
    const {handleError, showSuccess} = useApiNotification();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const resendInvite = async (id: any) => {
        if (folderId && groupId) {
            await resendInviteGroupGuest(organizationId, folderId, groupId, id)
        } else {
            await resendInviteProviderGuest(organizationId, id)
        }
    }

    const onResendInvite = async () => {
        try {
            await resendInvite(guest.id)
        } catch (e) {
            const error:any = _.get(e, 'response.data.error');
            if (error && error.type === 'CannotResendInviteToGuestNow') {
                const customMessage = t('_Common.Api.Messages.CannotResendInviteToGuestNow')
                    .replace('{0}', error.data.timeToWait);
                handleError({customMessage});
            } else {
                handleError(e);
            }
            handleClose()
            return;
        }
        showSuccess(t('_Common.Api.Messages.EmailResent'));
        handleClose()
    }

    return (
        <div>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon/>
            </IconButton>
            <Popover
                id={`long-menu${guest.id}`}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}>
                <List>
                    {
                        !guest.isActive &&
                        <ListItem>
                            <ListItemText
                                style={{cursor: 'pointer'}}
                                onClick={() => onResendInvite()}>
                                {t('MyGuests.ReInviteGuest')}
                            </ListItemText>
                        </ListItem>
                    }
                    <ListItem>
                        <ListItemText
                            style={{cursor: 'pointer'}}
                            onClick={() => {
                                onRemove(guest);
                                handleClose()
                            }}>
                            {t('MyGuests.RemoveGuest.Title')}
                        </ListItemText>
                    </ListItem>
                </List>
            </Popover>
        </div>
    )
};
